import React from 'react'
import { Row, Separator, Skeleton } from '@fs/zion-ui'

export default function MergeHeaderHeadingSkeleton(): JSX.Element {
  return (
    <>
      <Skeleton.H4 subheadingLineCount={1} width={98} />
      <Separator size="nano" />
      <Row wrap gutters="nano">
        <Skeleton.Chip width={98} inline />
        <Skeleton.Chip width={98} inline />
      </Row>
    </>
  )
}
